import React from "react";

interface SwitchButtonProps {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  icons: {
    value: string;
    icon: any;
  }[];
}

const SwitchButton: React.FC<SwitchButtonProps> = ({
  value,
  setValue,
  icons,
}) => {
  const handleSwitch = (value: string) => setValue(value);
  return (
    <div className="flex items-center gap-2 border border-darkBrown-70 bg-lightBrown-default text-darkBrown-70 rounded-lg px-3 py-2 select-none">
      {icons.map((icon, index) => {
        const isSelected = icon.value === value;

        return (
          <div
            className={`${
              isSelected ? "bg-darkBrown-5" : ""
            } cursor-pointer p-1.5 rounded-lg`}
            onClick={() => handleSwitch(icon.value)}
            key={index}
            style={{
              boxShadow: isSelected ? "0px 1px 2px 0px #1018280F" : "none",
            }}
          >
            {icon.icon}
          </div>
        );
      })}
    </div>
  );
};

export default SwitchButton;
